export class Anamnesis {
    cip: string;
    fecha: string;
    texto: string;
    linea: number;
    hora: string;
    visita: number;
    diagnostico: number;
    episodio: number;
    motivo: number;
    numExpediente: string;
    dniMed: string;
    idAnamnesis: number;
    seguimiento: string;
    dniBorrado: string;
    motivoBorrado: number;
    accion: string;
}



// WEBPACK FOOTER //
// ./src/models/anamnesis.ts